var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numberdisplay"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"number",class:{'green--text text--darken-2': _vm.result ? true : false}},[_vm._v(" "+_vm._s(_vm.number)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }